/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderDirectoryContact } from './ProviderDirectoryContact';
import {
    ProviderDirectoryContactFromJSON,
    ProviderDirectoryContactFromJSONTyped,
    ProviderDirectoryContactToJSON,
    ProviderDirectoryContactToJSONTyped,
} from './ProviderDirectoryContact';

/**
 * 
 * @export
 * @interface ListDirectoryContacts200Response
 */
export interface ListDirectoryContacts200Response {
    /**
     * 
     */
    data?: Array<ProviderDirectoryContact>;
}

/**
 * Check if a given object implements the ListDirectoryContacts200Response interface.
 */
export function instanceOfListDirectoryContacts200Response(value: object): value is ListDirectoryContacts200Response {
    return true;
}

export function ListDirectoryContacts200ResponseFromJSON(json: any): ListDirectoryContacts200Response {
    return ListDirectoryContacts200ResponseFromJSONTyped(json, false);
}

export function ListDirectoryContacts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDirectoryContacts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProviderDirectoryContactFromJSON)),
    };
}

export function ListDirectoryContacts200ResponseToJSON(json: any): ListDirectoryContacts200Response {
    return ListDirectoryContacts200ResponseToJSONTyped(json, false);
}

export function ListDirectoryContacts200ResponseToJSONTyped(value?: ListDirectoryContacts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProviderDirectoryContactToJSON)),
    };
}

